import React from 'react';
import './landing-courses.css';
import LandingCourseCard from "../landing-course-card/LandingCourseCard";
import aiCourseBG from '../../../assets/peEssentialsBlue_600x400.jpg';
import contentMasterclass from  '../../../assets/contentMasterclass_600x400.jpg';
import promptListBG from '../../../assets/prompt-list-600x400.jpg';
import TimerRush1 from '../elements-icons/TimerRush1';
import LighteningBolt1 from '../elements-icons/LighteningBolt1';
import TechRound1 from '../elements-svg/TechRound1';
import CountdownClock from "../elements-utils/countdown-clock/CountdownClock";
import CTAButton from "../cta-button/CTAButton";
import RightArrowCircular from "../elements-icons/RightArrowCircular";


const LandingCourses = () => {
  return (
    <section
      className='section-landing-courses'
      id='landing-courses'>
      <div className='wrapper-landing-courses'>
        <div className='section-landing-courses-svg-right'>
          <TechRound1 width='320px' />
        </div>
        <div className='wrapper-landing-courses-top'>
          <div className='content-landing-courses-intro'>
            <h2 className='title-sub-1 landing-courses-callout text-gradient-purple'>
              Ready for a Game-Changer?
            </h2>
            <div>
              <h2 className='title-sub-2 landing-courses-sub-callout'>
                Elevate Your Career with Our Premium Courses!
              </h2>
              <p className='paragraph-dk'>
                Gain an unfair advantage by mastering the art of prompt engineering. Designed specifically for business professionals, our courses cut through the tech jargon to deliver practical skills that will transform your workday.
              </p>
            </div>
          </div>
        </div>
        <div className='wrapper-landing-courses-pre-launch'>
          <h3 className='text-gradient-orange'>
            Coming Soon!
          </h3>
          {/* <CountdownClock
              targetDate='2023-12-18T00:00:00'
              clockWrapperClass='countdown-clock-wrapper'
              clockClass='countdown-clock'
              clockIntervalTitleClass='
              clock-interval-title
              semi-bold'
              clockIntervalClass='
              text-gradient-purple
              semi-bold
              drop-shadow
              clock-interval'
          /> */}
          <p className='pre-launch-content'>
            <span className='text-gradient-purple semi-bold'>For a limited time</span> you can get <span className='text-gradient-orange bold'>25% off</span> our first course "Prompt Engineering Essentials"...<br/><br/> <span className='text-gradient-orange bold'>PLUS!</span> As a bonus, you will get immediate access to download our <span className='text-gradient-purple semi-bold'>Prompt Master-List</span> containing all of the free prompts in the Prompt Library (with a few extras sprinkled in)! <br/><br/><span className='text-gradient-orange bold'>Stay tuned for exciting updates and pre-order details for our first course!</span>
          </p>
        </div>
        <div className='wrapper-landing-courses-bottom'>
          <LandingCourseCard
              courseTitle='Prompt Engineering Essentials'
              courseDescription='Discover the power of prompts and how they can transform everyday business operations. This hands-on course is designed for non-tech savvy professionals, guiding you through beginning to advanced prompt engineering methods in a language you understand. Unlock new efficiencies and ways of working that you never thought possible.'
              courseLength=''
              courseCost='16'
              discountType='percent'
              discountAmount='25'
              courseCostClass='text-purple'
              badgeContent='Beginner'
              badgeIcon={<LighteningBolt1
                  svgClass='icon-sm'
                  pathClass='badge-blue' />}
              ctaBtnContent='Coming Soon'
              ctaBtnIcon={<TimerRush1
                  svgClass='icon-md'
                  pathClass='icon-wht' />}
              imgSrc={aiCourseBG}
              imgAltText='Beginner Prompt Engineering Course'
          />
          <div className='connect-icon'>
            <h6 className='text-gradient-orange bold'>
              +
            </h6>
          </div>
          {/*<LandingCourseCard
              courseTitle='Content Creation Masterclass'
              courseDescription="Harness prompt engineering to elevate your content creation and storytelling. This course blends practical techniques with innovative strategies, perfect for creators aiming to captivate, educate, and inspire their audience. Learn to craft engaging narratives, enrich your material, and transform your communication approach, making every piece of content impactful and memorable."
              courseLength=''
              courseCost='16'
              discountType='percent'
              discountAmount='100'
              courseCostClass='text-purple'
              badgeContent='Intermediate'
              badgeIcon={<><LighteningBolt1
                  svgClass='icon-sm'
                  pathClass='badge-blue' /><LighteningBolt1
                  svgClass='icon-sm'
                  pathClass='badge-blue' /></>}
              ctaBtnContent='Coming Soon'
              ctaBtnIcon={<TimerRush1
                  svgClass='icon-md'
                  pathClass='icon-wht' />}
              imgSrc={contentMasterclass}
              imgAltText='Content Creation Masterclass'
          />
          <div className='connect-icon'>
            <h6 className='text-gradient-orange bold'>
              +
            </h6>
          </div> */}
          <LandingCourseCard
              courseTitle='66 Prompt Master List'
              courseDescription="Our full list of free prompts in one easy to access download, with a few goodies sprinkled in!"
              courseLength=''
              courseCost='4'
              discountType='percent'
              discountAmount='100'
              courseCostClass='text-purple'
              badgeContent='Beginner'
              badgeIcon={<><LighteningBolt1
                  svgClass='icon-sm'
                  pathClass='badge-blue' /></>}
              ctaBtnContent='Coming Soon'
              ctaBtnIcon={<TimerRush1
                  svgClass='icon-md'
                  pathClass='icon-wht' />}
              imgSrc={promptListBG}
              imgAltText='66 Prompt Master List'
          />
        </div>
      </div>
    </section>
  );
}

export default LandingCourses;